import { LiveSimulationItemDto } from '../../models/LiveSimulationsDto.model';

function useLiveExamsList() {
  function getStatus(simulation: LiveSimulationItemDto) {
    const { hasAnswered, hasLeaved } = simulation;

    if (hasAnswered) {
      return 'done';
    }

    if (!hasAnswered && hasLeaved) {
      return 'ongoing';
    }

    return 'notstarted';
  }

  return {
    getStatus,
  };
}

export { useLiveExamsList };
